import type { AxiosInstance } from 'axios';
import type * as SmartRoutingApi from './interfaces/smart-routing.js';
import qs from './utils/query-string.js';

export class SmartRoutingClient {
  constructor(private authenticatedClient: AxiosInstance) {}

  searchNearbyEntities = async (params: SmartRoutingApi.NearbyEntitiesSearch.Request) => {
    return this.authenticatedClient
      .post<SmartRoutingApi.NearbyEntitiesSearch.Response>('/smart-routing/nearby-entities/search', params)
      .then((response) => response.data);
  };

  getNearbyEntities = async (params: SmartRoutingApi.NearbyEntities.Request) => {
    return this.searchNearbyEntities({
      locationQuery: {
        latitude: params.lat,
        longitude: params.lon,
      },
      filters: {
        territoryId: params.territoryId,
        validEntities: params.validEntities,
        distanceRange: params.distanceRange,
      },
    });
  };

  searchEntities = async (params: SmartRoutingApi.SearchEntities.Request) => {
    const query = qs.stringify(params, { arrayFormat: 'bracket' });

    return this.authenticatedClient
      .get<SmartRoutingApi.SearchEntities.Response>(`/smart-routing/search-entities?${query}`)
      .then((response) => response.data);
  };

  getEntityById = async (params: SmartRoutingApi.GetEntityById.Request) => {
    const query = qs.stringify(params);

    return this.authenticatedClient
      .get<SmartRoutingApi.GetEntityById.Response>(`/smart-routing/entity?${query}`)
      .then((response) => response.data);
  };

  exportNearbyEntitiesCsv = async (
    params: SmartRoutingApi.ExportNearbyEntities.Request
  ): Promise<SmartRoutingApi.ExportNearbyEntities.Response> => {
    const response = await this.authenticatedClient.post<Blob>(
      '/smart-routing/export-nearby-entities',
      params,
      {
        responseType: 'blob',
      }
    );

    const contentDisposition = response.headers['content-disposition'] as string | undefined;
    const filename = contentDisposition ? new RegExp(/filename="(.+)"/).exec(contentDisposition)?.[1] : null;

    return {
      blob: response.data,
      filename: filename ?? null,
    };
  };
}
